import { Component, OnInit } from '@angular/core';
import { NotificationConfigService } from '../../services/notification-config.service';
import { NotificationConfig } from '../../beans/notification-config';

@Component({
	selector: 'app-notification-config',
	templateUrl: './notification-config.component.html',
	styleUrls: ['./notification-config.component.scss']
})
export class NotificationConfigComponent implements OnInit {

	configs: NotificationConfig[] = [];

	constructor(private configService: NotificationConfigService) { }

	ngOnInit() {
		this.load();
	}

	load() {
		this.configService.getAll().subscribe(r => this.configs = r);
	}

	save(c: NotificationConfig) {
		this.configService.save(c).subscribe(
			saved => {
				Object.assign(c, saved);
				alert('Запазено успешно!');
			},
			error => {
				alert('Грешка при запазване!');
			}
		);
	}

	refresh() {
		this.load();
	}
}
